import script from "./Login_bak.vue?vue&type=script&setup=true&lang=js"
export * from "./Login_bak.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__